module.exports = __webpack_public_path__ + "static/media/table_background_small.325de39f.jpg";